import { isEqual } from 'lodash';
import { catchError, finalize, of } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';

import { AuthService } from '../../services/auth/auth.service';
import { SharedService } from '../../services';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  template: '',
})
export class BaseRecoverPasswordComponent implements OnInit {
  showAlert: boolean;
  posId: string = '';
  resetError: boolean;
  showSuccess = false;
  forgotPasswordForm: FormGroup;
  isResetButtonDisabled: boolean;
  alert: { message: string } = {
    message: '',
  };
  constructor(
    protected formBuilder: FormBuilder,
    protected toastrService: ToastrService,
    protected sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected authService: AuthService,
    @Inject(DOCUMENT) protected document: Document,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
  }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    const initialValues = this.forgotPasswordForm.value;
    this.forgotPasswordForm.valueChanges.subscribe((ivalues) => {
      this.isResetButtonDisabled = isEqual(ivalues, initialValues);
    });
  }

  sendResetLink(): void {
    if (this.forgotPasswordForm.invalid) {
      return;
    }
    this.forgotPasswordForm.disable();
    this.showAlert = false;
    this.authService
      .forgotPassword(this.posId, this.forgotPasswordForm.get('email')?.value)
      .pipe(
        finalize(() => {
          this.forgotPasswordForm.enable();
          this.forgotPasswordForm.reset();
          this.showAlert = true;
        }),
        catchError(() => {
          this.showSuccess = false;
          this.resetError = true;
          this.alert = {
            message: 'There is no user with this email!',
          };
          this.toastrService.error('There is no user with this email!');
          this.changeDetectorRef.markForCheck();
          return of(null);
        }),
      )
      .subscribe((response) => {
        if (response) {
          this.isResetButtonDisabled = true;
          this.showSuccess = true;
          this.resetError = false;
          this.alert = {
            message: 'Réinitialisation du mot de passe envoyée ! Vous recevrez un e-mail si vous êtes inscrit sur notre système.',
          };
          this.toastrService.success('Réinitialisation du mot de passe envoyée ! Vous recevrez un e-mail si vous êtes inscrit sur notre système.');
        }
      });
  }
}
